<script>
import TableBlock from '@/components/Analysis/TableBlockMixin';

export default {
  mixins: [TableBlock],

  computed: {
    computedData() {
      const { averageTime, sites, filteredCollaboratorsCount, filteredCollaborators } = this.data;
      const computedSites = this.range ? sites.slice(this.range[0], this.range[1]) : sites;

      const currentSiteEntries = [
        {
          caption: this.$t('actualSites', this.data.actualSites.length),
          className: 'current-site site',
          type: 'current-site',
        },
        { caption: `${averageTime} min` },
        { caption: '', className: 'current-site' },
        { caption: '', className: 'current-site' },
      ];

      const entries = this.computeAverageTime(computedSites, averageTime, filteredCollaborators, this.forcedTransport).map((item, idx) => {
        item.push({
          type: 'summary-impact',
          className: {
            big: true,
          },
          site: sites[this.range ? this.range[0] + idx : idx].details.impact,
          attributes: {
            total: filteredCollaboratorsCount,
            radius: 30,
            innerRadius: 19,
          },
        });
        return item;
      });

      return {
        data: {
          specifications: [
            {
              className: {
                big: true,
              },
            },
            {
              type: 'heading',
              caption: this.$t('travelTime'),
            },
            {
              type: 'heading',
              caption: this.$t('evolution'),
            },
            {
              type: 'heading',
              caption: this.$t('report.impactOnCollaborators'),
              className: {
                big: true,
              },
            },
          ],
          entries: this.export ? entries : [currentSiteEntries, ...entries],
        },
      };
    },
  },
};
</script>
